<template>
    <div>
        <uax-editor id="tresc" :value="tresc" @input="val => $emit('update:tresc', val)"></uax-editor>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        "uax-editor": VueEditor
    },
    props: {
        tresc: {
            type: String,
            default: '',
        }
    }
};
</script>
